<header>
  <myre-navbar>
    <ng-container center>
      <myre-nav-logo
        [redirectUrl]="[baseUrl, 'operations']"
        logoUrl="assets/images/myre-symbol.svg"
      />
    </ng-container>
  </myre-navbar>
</header>

<div class="myre-container">
  <myre-layout>
    <myre-layout-row-container [phoneGutters]="true">
      <myre-layout-column>
        <div class="myre-white-box">
          <div class="content center" [style.backgroundImage]="background">
            <h1>{{ errorCode }}</h1>
            <p>
              {{ _wordings._system.errorPages[errorCode]() }}
            </p>
            <a
              routerLink="/"
              class="myre-button-primary"
              [ngClass]="{ green: errorCode === 404, red: errorCode !== 404 }"
            >
              {{ _wordings._system.indexHome() }}
            </a>
          </div>
        </div>
      </myre-layout-column>
    </myre-layout-row-container>
  </myre-layout>
</div>
